// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File manager. Roots: .documents-page and .documents-share-modal (portal). */

.documents-page__title {
  margin: 0 0 var(--ds-space-3);
  font-size: var(--ds-title-size);
  font-weight: 700;
  color: var(--ds-text);
}

/* Breadcrumb: one scrollable line on phones instead of wrapping into the grid. */
.documents-page__breadcrumb {
  margin-bottom: var(--ds-space-4);
  padding: var(--ds-space-1) var(--ds-space-3);
  overflow-x: auto;
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
}

.documents-page__breadcrumb .ant-breadcrumb ol {
  flex-wrap: nowrap;
  align-items: center;
  white-space: nowrap;
}

.documents-page__crumb {
  display: inline-flex;
  align-items: center;
  gap: var(--ds-space-1);
  min-height: 40px;
  padding: 0 var(--ds-space-1);
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.documents-page__crumb:hover {
  color: var(--ds-brand-strong);
}

.documents-page__crumb:focus-visible {
  outline: none;
  box-shadow: var(--ds-focus-ring);
  border-radius: var(--ds-radius-sm);
}

.documents-page__grid {
  margin-bottom: var(--ds-space-5);
}

.documents-page__empty {
  margin-top: var(--ds-space-8);
}

/* Cards */
.documents-page .file-card {
  height: 100%;
  overflow: hidden;
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-lg);
  box-shadow: var(--ds-shadow-xs);
  transition:
    box-shadow 0.2s ease,
    border-color 0.2s ease;
}

.documents-page .file-card:hover {
  border-color: var(--ds-brand);
  box-shadow: var(--ds-shadow-md);
}

.documents-page .file-card .ant-card-body {
  padding: var(--ds-space-3);
}

.documents-page .file-card .ant-card-actions > li {
  margin: 0;
}

.documents-page .file-card__more {
  height: 44px;
  border-radius: 0;
}

.documents-page .file-icon,
.documents-page .file-preview-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 104px;
  overflow: hidden;
  background: var(--ds-bg);
  border-bottom: 1px solid var(--ds-border-soft);
}

.documents-page .file-icon {
  padding: var(--ds-space-4);
}

.documents-page button.file-icon {
  border-width: 0 0 1px;
  cursor: pointer;
}

.documents-page .file-preview-container .ant-image {
  width: 100%;
  height: 100%;
}

.documents-page .file-title {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  min-width: 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--ds-text);
}

.documents-page .file-title__text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.documents-page .file-shared-icon {
  flex-shrink: 0;
  color: var(--ds-brand-strong);
}

.documents-page .file-size,
.documents-page .file-date,
.documents-page .file-description {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.75rem;
  color: var(--ds-text-muted);
}

@media (min-width: 768px) {
  .documents-page .file-icon,
  .documents-page .file-preview-container {
    height: 120px;
  }

  .documents-page .file-card .ant-card-body {
    padding: var(--ds-space-4);
  }
}

/* Share dialog */
.documents-share-modal .documents-share-modal__person {
  flex-wrap: wrap;
  gap: var(--ds-space-2);
}

.documents-share-modal .documents-share-modal__person .ant-list-item-meta {
  min-width: 0;
}

.documents-share-modal .documents-share-modal__person .ant-list-item-meta-description,
.documents-share-modal .documents-share-modal__person .ant-list-item-meta-title {
  overflow-wrap: anywhere;
}

.documents-share-modal .documents-share-modal__person .ant-list-item-action {
  margin-inline-start: auto;
}

.documents-share-modal .documents-share-modal__person .ant-select {
  min-width: 104px;
}

/* /documents renders without the panel shell (no content padding). */
.app-shell--bare .documents-page {
  padding: calc(var(--ds-page-pad) + var(--ds-safe-top))
    calc(var(--ds-page-pad) + var(--ds-safe-right)) calc(var(--ds-page-pad) + var(--ds-safe-bottom))
    calc(var(--ds-page-pad) + var(--ds-safe-left));
}
`, "",{"version":3,"sources":["webpack://./src/commons/documents/Documents.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,iFAAiF;AACjF;EACE,gCAAgC;EAChC,4CAA4C;EAC5C,gBAAgB;EAChB,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,UAAU;AACV;EACE,YAAY;EACZ,gBAAgB;EAChB,uCAAuC;EACvC,kCAAkC;EAClC,+BAA+B;EAC/B;;0BAEwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE;;kDAEgD;AAClD","sourcesContent":["/* File manager. Roots: .documents-page and .documents-share-modal (portal). */\n\n.documents-page__title {\n  margin: 0 0 var(--ds-space-3);\n  font-size: var(--ds-title-size);\n  font-weight: 700;\n  color: var(--ds-text);\n}\n\n/* Breadcrumb: one scrollable line on phones instead of wrapping into the grid. */\n.documents-page__breadcrumb {\n  margin-bottom: var(--ds-space-4);\n  padding: var(--ds-space-1) var(--ds-space-3);\n  overflow-x: auto;\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n}\n\n.documents-page__breadcrumb .ant-breadcrumb ol {\n  flex-wrap: nowrap;\n  align-items: center;\n  white-space: nowrap;\n}\n\n.documents-page__crumb {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--ds-space-1);\n  min-height: 40px;\n  padding: 0 var(--ds-space-1);\n  border: 0;\n  background: none;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n\n.documents-page__crumb:hover {\n  color: var(--ds-brand-strong);\n}\n\n.documents-page__crumb:focus-visible {\n  outline: none;\n  box-shadow: var(--ds-focus-ring);\n  border-radius: var(--ds-radius-sm);\n}\n\n.documents-page__grid {\n  margin-bottom: var(--ds-space-5);\n}\n\n.documents-page__empty {\n  margin-top: var(--ds-space-8);\n}\n\n/* Cards */\n.documents-page .file-card {\n  height: 100%;\n  overflow: hidden;\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-lg);\n  box-shadow: var(--ds-shadow-xs);\n  transition:\n    box-shadow 0.2s ease,\n    border-color 0.2s ease;\n}\n\n.documents-page .file-card:hover {\n  border-color: var(--ds-brand);\n  box-shadow: var(--ds-shadow-md);\n}\n\n.documents-page .file-card .ant-card-body {\n  padding: var(--ds-space-3);\n}\n\n.documents-page .file-card .ant-card-actions > li {\n  margin: 0;\n}\n\n.documents-page .file-card__more {\n  height: 44px;\n  border-radius: 0;\n}\n\n.documents-page .file-icon,\n.documents-page .file-preview-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 104px;\n  overflow: hidden;\n  background: var(--ds-bg);\n  border-bottom: 1px solid var(--ds-border-soft);\n}\n\n.documents-page .file-icon {\n  padding: var(--ds-space-4);\n}\n\n.documents-page button.file-icon {\n  border-width: 0 0 1px;\n  cursor: pointer;\n}\n\n.documents-page .file-preview-container .ant-image {\n  width: 100%;\n  height: 100%;\n}\n\n.documents-page .file-title {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  min-width: 0;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--ds-text);\n}\n\n.documents-page .file-title__text {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.documents-page .file-shared-icon {\n  flex-shrink: 0;\n  color: var(--ds-brand-strong);\n}\n\n.documents-page .file-size,\n.documents-page .file-date,\n.documents-page .file-description {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.75rem;\n  color: var(--ds-text-muted);\n}\n\n@media (min-width: 768px) {\n  .documents-page .file-icon,\n  .documents-page .file-preview-container {\n    height: 120px;\n  }\n\n  .documents-page .file-card .ant-card-body {\n    padding: var(--ds-space-4);\n  }\n}\n\n/* Share dialog */\n.documents-share-modal .documents-share-modal__person {\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n}\n\n.documents-share-modal .documents-share-modal__person .ant-list-item-meta {\n  min-width: 0;\n}\n\n.documents-share-modal .documents-share-modal__person .ant-list-item-meta-description,\n.documents-share-modal .documents-share-modal__person .ant-list-item-meta-title {\n  overflow-wrap: anywhere;\n}\n\n.documents-share-modal .documents-share-modal__person .ant-list-item-action {\n  margin-inline-start: auto;\n}\n\n.documents-share-modal .documents-share-modal__person .ant-select {\n  min-width: 104px;\n}\n\n/* /documents renders without the panel shell (no content padding). */\n.app-shell--bare .documents-page {\n  padding: calc(var(--ds-page-pad) + var(--ds-safe-top))\n    calc(var(--ds-page-pad) + var(--ds-safe-right)) calc(var(--ds-page-pad) + var(--ds-safe-bottom))\n    calc(var(--ds-page-pad) + var(--ds-safe-left));\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
